import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import cn from 'classnames';
import { withNavigation } from '@topconagriculture/frontend-utils';
import { ButtonVariants } from '../Button/Button';
import { Button } from '../Button';
const styles = (theme) => createStyles({
    root: {},
    sectionButton: {
        minHeight: 80,
    },
});
const SectionMenuButton = (props) => {
    const { classes, className: classNameProp, label, disabled, onClickHandler, path, goToHandler, match, subRoute, testId = 'SectionMenuButton-' + label, } = props;
    const fullPath = subRoute ? `${match.url}${path}` : path;
    const onClickFn = fullPath ? goToHandler(fullPath, false) : onClickHandler;
    return (React.createElement(Button, { fullWidth: true, role: ButtonVariants.branded, label: label, disabled: disabled, onClick: onClickFn, "data-testid": `${testId}`, className: cn(classes.sectionButton, classNameProp) }));
};
const ComposedSectionMenuButton = compose(withNavigation, withStyles(styles, { withTheme: true }), pure)(SectionMenuButton);
ComposedSectionMenuButton.displayName = 'SectionMenuButton';
export default ComposedSectionMenuButton;
//# sourceMappingURL=SectionMenuButton.js.map